export default {"src":"/_next/static/media/google-calendar.db6a4d49.svg","height":38,"width":38,"blurWidth":0,"blurHeight":0};